import { useQuery } from 'react-query';

import { useToasts } from '@savgroup-front-common/core/molecules/NotificationsProvider';
import { ClaimService } from '@/api';

const useGetClaimReasons = ({ claimGroupId }: { claimGroupId: string }) => {
  const { pushErrors } = useToasts();

  const { data: reasons } = useQuery(
    ['getClaimGroupReasonsQuery', { claimGroupId }],
    async () => {
      if (!claimGroupId) {
        return undefined;
      }

      const response = await ClaimService.getClaimGroupReasonsQuery({
        claimGroupId,
      });

      if (response.failure) {
        pushErrors(response.errors);

        return undefined;
      }

      return response.value;
    },
    { suspense: true },
  );

  return { reasons };
};

export default useGetClaimReasons;
